import React from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomRadioButton from "../../CustomRadioButton";
import {
  pushToHistoryAction,
  setVisibility,
} from "../../../../redux/reducers/segmentBuilder";
import { getVisibility } from "../../../../redux/selectors/segmentBuilderSelectors";
import TextView from "../../../TextView";
import { Container } from "../../CreateWheelPopup.styled";
function Second() {
  const dispatch = useDispatch();
  const visibility = useSelector(getVisibility);

  const handlePublicPrivateHiddenChange = (event) => {
    dispatch(setVisibility(event.target.value));
  };

  return (
    <Container>
      <TextView
        variant="title"
        style={{ textAlign: "center", marginBottom: "20px" }}
      >
        Do you want this wheel visible to guests on your gallery?
      </TextView>
      <CustomRadioButton
        options={[
          {
            value: 1,
            label: "Public",
            tooltip: (
              <div>
                <TextView>
                  Public wheels can be viewed by visitors to your gallery.
                </TextView>
              </div>
            ),
          },
          {
            value: 2,
            label: "Private",
            tooltip: (
              <div>
                <TextView>
                  Private wheels are not visible to visitors and can only be
                  accessed if someone has the URL.
                </TextView>
              </div>
            ),
          },
          {
            value: 3,
            label: "Hidden",
            tooltip: (
              <div>
                <TextView>
                  Wheel is NOT visible to others and CANNOT be accessed with its
                  URL.
                </TextView>
              </div>
            ),
          },
        ]}
        selectedOption={visibility}
        onChange={handlePublicPrivateHiddenChange}
        orientation="vertical"
      />
    </Container>
  );
}

export default Second;
